/* eslint-disable prettier/prettier */
<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="
            $route.params.id ? $t('Edit Edgespacer') : $t('New Edgespacer')
          "
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-text-field
              v-model="formValues.name"
              label="Name"
              v-validate="'required'"
              required
              data-vv-name="name"
              :error-messages="errors.collect('name')"
            ></v-text-field>
            <v-text-field
              v-model="formValues.psi"
              label="PSI"
              v-validate="'required'"
              type="number"
              required
              data-vv-name="psi"
              :error-messages="errors.collect('psi')"
            ></v-text-field>
            <v-card-actions class="pl-0">
              <v-btn
                color="primary"
                class="mr-4"
                @click="$router.push({ name: 'edgeSpacer.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
import { fetchCategories, fetchItems } from "../../items/shared/services";
export default {
  name: "app-edgeSpacer-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: "",
        psi: ""
      },
      permissions: [],
      loading: true
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "edgeSpacer.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
